import React from 'react'
import { Contexts, Types } from '../types'
import _ from 'lodash'
import { useProductAttributes } from '../hooks/useProductAttributes';
import { useDebug } from '../hooks';
 //     // ['instock', 'onbackorder'].includes( product.stockStatus )
const initialState: any = {
    id: 0, // number
    name: '', // string
    description: undefined, // string|undefined if not set  
    permalink: null,
    images: {
        feature: undefined,
        gallery: []
    }, // string(imageURL)|string[(imageURLsr)]| undefined >> config.defaultImage
    gallery: undefined, // undefined if any 
    type: 'variable', // string
    stockStatus: 'outofstock', // instock|outofstock, thats question
    manageStock: true, // boolean
    taxClass: 'standard',  // string
    meta: { // Addditional meta
        deliveryTime: undefined, // undefined if not set
    },
    price: undefined, // undefined if type IN [variable]
    quantity: {
        min: 1,
        selected: 1
    }, // undefined if manageStock == false || isVariable
    available: true,
    purchasable: true,
    // Selected atts list 
}

export const VariableProductContext = React.createContext<any>({}) 

// children, attributes, config, translations, product: {variations, ...productData}, onAddToCart, onSelect: handleVariationSelect
const VariableProductProvider: React.FC<any> = ({ children, config, translations, product: {variations, attributesMeta: attributes, attributes: availableAttributeTaxonomies, ...product}, onAddToCart: handleAddToCart, onVariationSelect }) => {    

    useDebug(`VariableProductProvider [${product.name}}]`);

    const [store, updateStore] = React.useState<any>({...initialState});
    const { id: selectedVariationID, attributes: {selected: selectedAttributes, available: availableAttributes}, handleSelect: handleAttributesSelect } = useProductAttributes({attributes, variations});
    
    const setState = (key: string, value: any) => {
        if (!(key in initialState)) throw Error(`Key ${key} is not valid state.`);
        if ( store[key] === value ) return;
        updateStore((prevStore: any) => ({ ...prevStore, [key]: value instanceof Function ? value(prevStore[key]) : value }))
    }
        
    const productData = React.useMemo(() => _.merge(
        store, 
        product,
    ), [product, store]);

    const handleVariationSelect = React.useCallback((variationID) => {
        if ( ! onVariationSelect || _.isEmpty(selectedAttributes) || _.isEmpty(availableAttributes ) ) return;
        onVariationSelect instanceof Function && onVariationSelect({
            id: productData.id, 
            variation: variationID, 
            quantity: productData.quantity.selected
        });
    }, [productData.id, productData.quantity.selected, onVariationSelect, selectedAttributes, availableAttributes]);

    const onAddToCart = React.useCallback(() => {
        handleAddToCart({...productData, selected: selectedVariationID});
    }, [productData, selectedVariationID])
        
    React.useEffect(() => handleVariationSelect(selectedVariationID), [handleVariationSelect, selectedVariationID]); // handleVariationSelect

    if ( _.isEmpty( variations ) ) return null;

    return (
        <VariableProductContext.Provider
            value={{
                ...productData,
                attributes,
                selectedVariation: selectedVariationID && selectedVariationID in variations ? variations[selectedVariationID] : {},
                options: {
                    selected: selectedAttributes,
                    available: availableAttributes
                },
                config,
                translations,
                handleAttributesSelect,
                onAddToCart,
                setState,
            }}
            children={!_.isEmpty(selectedAttributes) && !_.isEmpty(availableAttributes) ? children : null }
        />
    ) 
    
}

export default VariableProductProvider;